import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub,  } from "react-icons/ai";
import { FaLinkedinIn, FaGoogle } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Shivam Tripathi</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} Shivam Tripathi</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/shivamtpathi"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/shivam-tripathi2000/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            
            <li className="social-icons">
              <a
              href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=omhishiv@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hello%20Shivam%20Tripathi,"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGoogle />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
